import BaseService from "./BaseService";

export class ScheduleLimitationService extends BaseService {
	constructor() {
		super('/scheduleLimitation');
	}
}
